import { Component, Prop, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import TextRow from '@/forms/FormElements/Rows/TextRow/TextRow.vue';

import RowValidationMixin from '@/forms/FormElements/Mixins/RowValidationMixin';

import { names } from './PhoneRow.validation';
import { getCountryData } from '@/api/CountryStateApi';
import { CleaveOptions } from 'cleave.js/options';
import { getPhoneCodeFormatter, getPhoneNumberFormatter } from '@/forms/Formatters';
import { getStore } from '@/store';

@Component({ components: { TextRow } })
export default class PhoneRow extends mixins(RowValidationMixin) {
  @Prop({ type: String, default: 'Phone number' })
  readonly label!: string;

  @Prop({ type: String, default: ' ' })
  readonly placeholder!: string;

  @Prop({ type: Boolean, default: false })
  readonly multiple!: boolean;

  @Prop()
  readonly countryId!: Number | String;

  @Watch('countryId')
  countryIdChange(val: Number | String) {
    const country = getCountryData().Countries.find((c) => c.Value == val);
    this.model[names.Code] = country?.PhoneCode;
  }

  isCodeMutated = false;

  names = names;

  codeFormatter: CleaveOptions = getPhoneCodeFormatter();

  get numberFormatter(): CleaveOptions {
    const country = getStore().state.Meta.Country
    return getPhoneNumberFormatter(country === 5 || country === 6)
  }
}
